class LaborCostCtrl {
  constructor(Authentication, TabsControl, AccountService, SubscriptionUtils, $state, $scope) {
    'ngInject';

    this.tabs = [
      { value: 'employees', label: 'Employees' },
      { value: 'positions', label: 'Positions' },
      { value: 'locations', label: 'Locations' },
    ];

    this.tabsControl = new TabsControl(this.tabs, 'employees');

    Object.assign(this, {
      Authentication,
      TabsControl,
      AccountService,
      SubscriptionUtils,
      $state,
      $scope,
    });

    $scope.$on('$destroy', () => this.tabsControl.destroy());
  }

  changeTab(tab) {
    if (tab === this.tabsControl.activeTab) {
      return;
    }

    this.tabsControl.changeTab(tab);
    this.$state.go('.', { tab: tab.value });
    this.$scope.$broadcast('vsRepeatTrigger');
  }
}

export default LaborCostCtrl;
